import React, { useContext, useEffect, useState } from 'react'
// import PlaylistPlayer from '../../../container/player/playlistPlayer'
import { ContentContext } from '../../../context/content'
import { SubscriptionContext } from '../../../context/subscription'
import { AppContext } from '../../../context/app'
import useAxios from 'axios-hooks'
import { isEmpty } from 'lodash'
import { AD_CAMPAIGN, CONTENT_WATCH_URL, DETAIL_CONTENT } from '../../../utils/apiUrls'
import LiveCounter from '../../../container/contentDetail/liveCounter'
import { useInterval } from '../../../hooks/useInterval'
import LockIcon from '../../../assets/lock-icon.svg'
import { useTranslation } from 'react-i18next'
import PlayerHome from '../../../container/playerTemplate'
import { useLocation } from 'react-router'

const BasicContentPlayer = ({
  data,
  controlBar,
  onVideoComplete = () => {},
  handleNext = null,
  handlePrev = null,
  stillWatchingAllowed = false,
  loader = true,
}) => {
  const contentId = data.id
  const {
    isLogin,
    setLoader,
    setOpenLoginModal,
    setModalType,
    accountObj,
    userObj,
    setVerifyOtpModalData,
  } = useContext(AppContext)
  const { setOpenSubscriptionModal, setSubscriptions, setRedirectionUrl, setContentPartners } =
    useContext(SubscriptionContext)
  const { setIsVideoPlaying, getResumeTimestamp } = useContext(ContentContext)

  const [playingVideo, setPlayingVideo] = useState(false)
  const location = useLocation()

  const [detailObj, setDetailObj] = useState()
  const [isLive, setIsLive] = useState(false)
  const [endTime, setEndTime] = useState(null)
  const [isContentSubscribed, setIsContentSubscribed] = useState(true)
  const [adCampaignData, setAdCampaignData] = useState({})
  const [resumeTime, setResumeTime] = useState(0)
  const [isEmailUnVerified, setIsEmailUnVerified] = useState(false)
  const [videoURLError, setVideoURLError] = useState('')
  const { t } = useTranslation()

  const isStartOver = location?.state?.isStartOver

  const [{ data: contentDetail, loading: contentLoading }, contentDetailCall] = useAxios(
    {
      url: `${DETAIL_CONTENT}${contentId}`,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: contentWatchUrl, error: contentUrlError }, getContentWatchUrl] = useAxios(
    {
      url: `${CONTENT_WATCH_URL}${contentId}`,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: adCampaignRes }] = useAxios({
    url: `${AD_CAMPAIGN}${contentId}`,
    method: 'get',
  })

  useEffect(() => {
    if (adCampaignRes?.success) {
      setAdCampaignData(adCampaignRes.data)
    }
  }, [adCampaignRes])

  useEffect(() => {
    if (contentId) {
      setDetailObj({})
      setPlayingVideo(false)
      setIsLive(false)
      contentDetailCall()
      if (isLogin && !isStartOver) {
        setResumeTime(getResumeTimestamp(contentId))
      }
    }
  }, [contentId])

  useEffect(() => {
    if (isLogin) {
      contentDetailCall()
    }
  }, [isLogin])

  useEffect(async () => {
    if (!isEmpty(detailObj)) {
      if (detailObj?.video_type.includes('LIVE') && !isLive) {
        return
      }
      if (await checkRestriction()) {
        get_video_url(detailObj)
      }
    }
  }, [detailObj, isLive, isLogin])

  useEffect(() => {
    if (contentDetail && contentDetail.success) {
      const contentObj = contentDetail.data
      setDetailObj(contentObj)
      if (contentObj?.video_type?.includes('LIVE')) {
        let publishTime = new Date(contentObj.publish_time + 'Z')
        if (contentObj?.video_type === 'VOD_LIVE' && isEmpty(contentObj?.youtube_data)) {
          setEndTime(
            new Date(
              publishTime.setSeconds(publishTime.getSeconds() + contentObj.duration_in_s),
            ).getTime(),
          )
        } else {
          setEndTime(new Date(contentObj.live_expiry_time + 'Z').getTime())
        }
        if (
          (new Date(contentObj.publish_time + 'Z').getTime() < Date.now() &&
            (!isEmpty(contentObj?.youtube_data) ||
              new Date(
                publishTime.setSeconds(publishTime.getSeconds() + contentObj.duration_in_s),
              ).getTime() > Date.now()) &&
            contentObj?.video_type === 'VOD_LIVE') ||
          (new Date(contentObj.publish_time + 'Z').getTime() < Date.now() &&
            new Date(contentObj.live_expiry_time + 'Z').getTime() > Date.now())
        ) {
          setIsLive(true)
        }
      }
    }
  }, [contentDetail])

  useEffect(() => {
    if (contentWatchUrl && contentWatchUrl.success) {
      setPlayingVideo(true)
      setIsVideoPlaying(true)
    }
  }, [contentWatchUrl])

  useEffect(() => {
    if (contentUrlError?.response) {
      setVideoURLError(contentUrlError?.response?.data?.message)
    }
  }, [contentUrlError])

  useEffect(() => {
    setLoader(loader && isEmpty(detailObj) && contentLoading)
  }, [contentLoading, loader])

  const get_video_url = (detailObj) => {
    if (detailObj.video_type === 'LIVE' || !isEmpty(detailObj?.youtube_data)) {
      setPlayingVideo(true)
      setIsVideoPlaying(true)
    } else {
      getContentWatchUrl()
    }
  }

  const checkRestriction = (openModal = false) => {
    if (detailObj.video_type === 'LIVE' && endTime < Date.now()) {
      return false
    }

    if (!detailObj.is_restricted) {
      if (detailObj.is_login_required && !isLogin) {
        setIsContentSubscribed(false)
        if (openModal) {
          setModalType('login')
          setOpenLoginModal(true)
        }
        return false
      }
      if (
        detailObj.is_login_required &&
        isLogin &&
        accountObj?.od_resource_allowances?.verify_email_mandatory &&
        !userObj?.is_email_verified
      ) {
        setVerifyOtpModalData({ title: t('verify_your_email'), email: userObj?.email_id })
        setIsEmailUnVerified(true)

        return false
      }
      return true
    } else {
      if (!isLogin) {
        if (openModal) {
          setModalType('login')
          setOpenLoginModal(true)
        }
        setIsContentSubscribed(false)
        return false
      } else {
        if (
          accountObj?.od_resource_allowances?.verify_email_mandatory &&
          !userObj?.is_email_verified
        ) {
          setVerifyOtpModalData({ title: t('verify_your_email'), email: userObj?.email_id })
          setIsEmailUnVerified(true)
          return false
        }

        if (detailObj?.is_purchased_required) {
          let contentSub = [
            ...detailObj.active_subscription.map((item) => item.id),
            ...detailObj.active_ppv_subscription.map((item) => item.id),
          ]

          setIsContentSubscribed(false)
          if (openModal) {
            setRedirectionUrl(window.location.pathname)
            setContentPartners(detailObj?.owner ? detailObj?.owner : [])
            setSubscriptions(contentSub)
            setOpenSubscriptionModal(true)
          }
        } else {
          return true
        }
        return false
      }
    }
  }

  const onCounterComplete = () => {
    setIsLive(true)
  }

  useInterval(
    async () => {
      if (endTime) {
        const time = Date.now()

        if (time >= endTime) {
          setIsLive(false)
          setPlayingVideo(false)
          setIsVideoPlaying(false)
        }
      }
    },
    endTime && Date.now() < endTime ? 1000 : null,
  )

  return (
    <div className="w-full h-full">
      {detailObj && (
        <>
          {playingVideo ? (
            <PlayerHome
              contentInfo={detailObj}
              contentWatchUrl={
                !isEmpty(detailObj?.youtube_data)
                  ? ''
                  : detailObj?.video_type === 'LIVE'
                  ? detailObj?.stream.link
                  : contentWatchUrl?.data?.signed_url
              }
              resumeTime={resumeTime}
              handlePlayingSequence={() => {}}
              disableHeader={true}
              loop={false}
              controlBar={controlBar}
              adCampaignData={adCampaignData}
              onVideoComplete={onVideoComplete}
              handleNext={handleNext}
              handlePrev={handlePrev}
              stillWatchingAllowed={stillWatchingAllowed}
            />
          ) : (
            <div className=" w-full h-full bg-black">
              {videoURLError ? (
                <div className="w-full h-full flex justify-center items-center ">
                  <div className=" w-4/5 md:w-fit">
                    <p
                      style={{ color: '#cecece' }}
                      className="md:ml-2 text-xs md:text-base xl:text-lg text-center font-semibold"
                    >
                      {videoURLError}
                    </p>
                  </div>
                </div>
              ) : null}
              {detailObj?.video_type?.includes('LIVE') && !isLive && endTime > Date.now() && (
                <div className="flex relative justify-center w-full h-full">
                  <LiveCounter
                    styles={{ top: '32%' }}
                    counterClass={' w-4/5 lg:w-fit'}
                    contentDetail={detailObj}
                    handleCompletion={onCounterComplete}
                  />
                </div>
              )}
              {detailObj.video_type?.includes('LIVE') && endTime < Date.now() && (
                <div className="w-full h-full flex justify-center items-center ">
                  <button
                    style={{ background: '#09e9e9', color: 'whitesmoke' }}
                    className="w-fit text-xs md:text-base xl:text-lg rounded-md xl:rounded-lg py-1 px-3"
                    disabled={true}
                  >
                    {t('stream_ended')}
                  </button>
                </div>
              )}

              {(!isContentSubscribed || isEmailUnVerified) && (
                <div className="w-full h-full flex justify-center items-center ">
                  <div className=" w-4/5 md:w-fit">
                    <div className="flex px-5 md:px-0">
                      <img
                        src={LockIcon}
                        style={{
                          width: '18.5px',
                          height: '24.6px',
                        }}
                        alt="LockIcon"
                      />
                      <p
                        style={{ color: '#cecece' }}
                        className="md:ml-2 text-xs md:text-base xl:text-lg text-center "
                      >
                        {isEmailUnVerified
                          ? t('account_not_verified')
                          : t('not_include_in_membership')}
                      </p>
                    </div>
                    <button
                      style={{ background: '#09e9e9', color: '#000' }}
                      className="w-full text-xs md:text-base xl:text-lg rounded-md xl:rounded-lg mt-4 xl:mt-6 py-1"
                      onClick={() => checkRestriction(true)}
                    >
                      {isEmailUnVerified ? t('verify_account') : t('upgrade_membership_to_watch')}
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default BasicContentPlayer
